import { endOfDay, isPast } from 'date-fns';
import { WEEKDAY_NARROW_FORMAT_LANGUAGES, extractLanguageCode, } from 'wix-style-react-tpa/dist/es/src/common/LocaleUtils/LocaleUtils';
export const getFirstDayInMonth = (month) => {
    return new Date(month.getFullYear(), month.getMonth(), 1);
};
export const formatShortWeekDayName = (date, locale) => {
    const language = extractLanguageCode(locale);
    const weekdayIntlFormat = WEEKDAY_NARROW_FORMAT_LANGUAGES[language]
        ? 'narrow'
        : 'short';
    return new Intl.DateTimeFormat(locale, {
        weekday: weekdayIntlFormat,
    }).format(date);
};
export const formatLongWeekDayName = (date, locale) => {
    return new Intl.DateTimeFormat(locale, {}).format(date);
};
export const formatDay = (date, locale) => {
    return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
};
export const getFirstAvailableDate = ({ startOfWeekDate, filterDate, excludePastDates, }) => {
    const currentDateToCheck = new Date(startOfWeekDate);
    for (let i = 0; i < 7; i++) {
        if (filterDate(currentDateToCheck) &&
            !(excludePastDates && isPast(endOfDay(currentDateToCheck)))) {
            return currentDateToCheck;
        }
        currentDateToCheck.setDate(currentDateToCheck.getDate() + 1);
    }
    return startOfWeekDate;
};
export const formatDateForDataAttr = (date) => `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
//# sourceMappingURL=dateUtils.js.map